import { createAction, props } from "@ngrx/store";

import { DataTransactionParams } from "../../definitions/api/shared/data-transaction-params";
import { FailState } from "../models/fail-state";
import { DataTransactionsState } from "../models/shared/data-transactions-state";

export class DataTransactionActions {
	static readonly dataTransactions = {
		get: createAction("[Data Transactions] get", props<{ params?: DataTransactionParams }>()),
		getApi: createAction(
			"[dataTransaction] get api",
			props<{ params?: DataTransactionParams }>()
		),
		getSuccess: createAction("[Data Transactions] get success", props<DataTransactionsState>()),
		getFail: createAction("[Data Transactions] get fail", props<FailState>())
	};
}
